import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_36: DocMigration = {
  maxSchemaVersion: "0.0.36",
  apply(json: any) {
    const value = json.planOutputConfig.interiorDimensionStyle?.type ?? "BY_STRING";
    delete json.planOutputConfig.interiorDimensionStyle;
    if (typeof json.settingsOverride?.planset !== "string") {
      const newId = uid();
      json.tables.settings[newId] = {
        type: "PLAN_SETTINGS",
        interiorDimensionType: value,
      };
      if (!json.settingsOverride) {
        json.settingsOverride = {};
      }
      json.settingsOverride.planset = newId;
    } else {
      json.tables.settings[json.settingsOverride.planset].interiorDimensionType = value;
    }
    return json;
  },
};

export default migration_0_0_36;
